/* ============
 * Dashboard
 * ============
 *
 * This is the dashboard page.
 */

import packageService from './../../services/package';
import packageOrderProductService from './../../services/packageOrderProduct';
import orderProductService from './../../services/orderProduct';
import { mapGetters, mapMutations } from 'vuex';
import Forms from './../../utils/forms/forms';

export default {
  data() {
    return {
      form: new Forms({
        packageUnitTypeId: {
          value: '',
          type: 'select',
        },
        packingLevel: {
          value: '',
          type: 'select',
        },
        parentId: {
          value: '',
          type: 'select',
        },
        sscc: {
          value: '',
          type: 'text',
        },
        id: {
          value: '',
          type: 'hidden',
        },
      }),
      loading: false,
    };
  },

  computed: {
    ...mapGetters({
      currentOrder: 'currentOrder',
      orderProducts: 'allOrderProducts',
      parentIds: 'deliveryPackages',
      packageUnitTypes: 'allPackageUnitTypes',
    }),

    loadForms() {
      var element = this;
      const type = [
        {"id": "2", "name": "Pallet"},
        {"id": "3", "name": "Box"}
      ];
      this.form.setOptions('packingLevel', type);
      this.form.setOptions('parentId', this.parentIds.all.filter(function(p) {
        return p.packingLevel == 2 && p.id != element.$store.state.modal.modalProps.id;  
      }));
      this.form.setOptions('packageUnitTypeId', this.packageUnitTypes.all);
      this.form.hideField('parentId');
      this.form.assignData(this.$store.state.modal.modalProps);
      this.form.setFieldValue('parentId', '');
    }, 
  },

  created() {
    this.loadForms;
    this.form.disableField('orderProductId')
  },

  watch:{
    'form.packingLevel': function (typeId) {
      if(typeId.toString() == 2) {
        this.form.hideField('parentId');
      } else if (typeId.toString() == 3) {
        this.form.showField('parentId');
      }
    },
  },

  methods: {
    ...mapMutations({
      toggle: 'TOGGLE_MODAL',
      unsetModalContent: 'UNSET_MODAL_CONTENT',
      modalProps: 'SET_MODAL_PROPS',
    }),

    /*
    * Invoked upon clicking the "save button"
    * 
    */

    update(){
      this.form.loading = true;
      packageService.update(this.form.id, this.form.data())
      .then((data) => {
        orderProductService.all(this.currentOrder.id);
        packageOrderProductService.all(this.currentOrder.id)
        packageService.all(this.currentOrder.id)
        this.$message({
            showClose: true,
            message: this.$t('static.packageOrderProduct.edit.success'),
            customClass: 'success',
        });
        this.closeModal();
      })
      .catch((errors) => {
        this.form.loading = false;
        this.form.recordErrors(errors);
        let message = this.$t('static.packageOrderProduct.edit.error');
        if (errors.quantityExceedError) {
          message = this.$t('static.packageOrderProduct.edit.quantityExceedError');
        }
        this.$message({
          showClose: true,
          message,
          customClass: 'error',
        });
      });
    },
    /*
    * Closes the modal
    */
    closeModal() {
      this.toggle(false);
      this.unsetModalContent();
    },
  },
  components: {
    VForm: require('./../../components/form/form.vue'),
    VMessage: require('./../../components/form/message/message.vue'),
  },
};



// WEBPACK FOOTER //
// ./src/app/components/editPackage/editPackage.js